import { render, staticRenderFns } from "./MessageType.vue?vue&type=template&id=19c60b7a&"
import script from "./MessageType.vue?vue&type=script&lang=ts&"
export * from "./MessageType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports